(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  function initCollectionSlider() {
    var $ = window.jQuery;

    if (typeof $ === "undefined") {
      console.error("jQuery not found. Slick Slider won't work.");
      return;
    }

    var $slider = $('.collection-slider');

    if ($slider.length && typeof $slider.slick === 'function') {
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          prevArrow: $('.prev-arrow'),
          nextArrow: $('.next-arrow'),
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    } else {
      console.warn("Slick not initialized. Check if Slick JS loaded properly.");
    }
  }

  // Safe initialization after DOM is ready
  document.addEventListener("DOMContentLoaded", function () {
    var checkReady = setInterval(function () {
      if (window.jQuery && typeof jQuery.fn.slick !== 'undefined') {
        initCollectionSlider();
        clearInterval(checkReady);
      }
    }, 100);
  });

  // Optional: Re-init if Shopify loads section via AJAX (for theme editor)
  document.addEventListener("shopify:section:load", function () {
    initCollectionSlider();
  });

  } catch(e) { console.error(e); }
})();
})();
